import styles from './AtcWorkTime.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import React, {useEffect, useRef, useState} from "react";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import InputItemLight from "../../FormTemplate/InputItemLight/InputItemLight";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WorkLine from "../../FormTemplate/WorkLine/WorkLine";
import ButtonContainer from "../../FormTemplate/ButtonContainer/ButtonContainer";
import useApiQuery from "../../ApiQuery/UseApiQuery";
interface IDayItem{
    enabled: boolean
    name:string
    day:number
    [key:string]:any

    startTimeH?:string
    startTimeM?:string

    endTimeH?:string
    endTimeM?:string

}
export default function AtcWorkTime(){

    const updateData = useRef<{
        workTime: any[],
        locale:number
    }>()
    const [ldrUpdate,rsUpdate,exUpdate] = useApiQuery("/ref/sysoption/worktime/update","post",updateData);

    const loadData = useRef<string>()
    const [ldrLoad,rsLoad,exLoad] = useApiQuery("/ref/sysoption/worktime/load","post",loadData);

    const [locale, setLocale] = useState(0)
    const [localeStr, setLocaleStr] = useState("0")

    const refState = useRef<ErrorLineItemRef>(null)
    const [dayList, setDayList] = useState<IDayItem[]>([
        {
            day:0,
            enabled: true,
            name: "ПН",
        },
        {
            day:1,
            enabled: true,
            name: "ВТ",
        },
        {
            day:2,
            enabled: true,
            name: "СР",
        },
        {
            day:3,
            enabled: true,
            name: "ЧТ",
        },
        {
            day:4,
            enabled: true,
            name: "ПТ",
        },
        {
            day:5,
            enabled: true,
            name: "СБ",
        },
        {
            day:6,
            enabled: true,
            name: "ВС",
        },

    ])


    useEffect(()=>{
        loadList()
    },[loadData])

    const loadList = ()=>{
        exLoad().then((e)=>{
            if(e?.success){
                const x = e?.payload?.workTime
                if(Array.isArray(x)){
                    const data = new Array<IDayItem>()
                    const success = x?.reduce((acc,item)=>{
                        if(! Array.isArray(item) || item?.length < 4) return false
                        let dayName = "ХЗ"
                        switch (item[0]){
                            case 0:
                                dayName = "ПН"
                                break
                            case 1:
                                dayName = "ВТ"
                                break
                            case 2:
                                dayName = "СР"
                                break
                            case 3:
                                dayName = "ЧТ"
                                break
                            case 4:
                                dayName = "ПТ"
                                break
                            case 5:
                                dayName = "СБ"
                                break
                            case 6:
                                dayName = "ВС"
                                break
                        }

                        console.log(item,item[3]?.substring(2,4))
                        const px:IDayItem = {
                            enabled: item[1] === 1,
                            day: item[0],
                            name: dayName,
                            startTimeH: item[2]?.substring(0,2),
                            startTimeM: item[2]?.substring(2,4),

                            endTimeH: item[3]?.substring(0,2),
                            endTimeM: item[3]?.substring(2,4),
                        }
                        data?.push(px)

                        return acc
                    },true)

                    if( success) {
                        if(refState.current)refState.current.show("Расписание загружено", false, 5000)
                        setDayList(data)

                        console.log(data)
                        setLocale(e?.payload?.locale)
                        setLocaleStr(e?.payload?.locale?.toString())

                        return;
                    }


                }
                if(refState.current)refState.current.show("Ошибка формата данных с сервера", true, 0)


                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 0)

        })

    }

    const handleUpdate = () =>{
        let xArray = new Array<any>()

        dayList?.map((item)=>{
            const x = new Array()
            x?.push(item?.day)
            x?.push(item?.enabled ? 1: 0 )
            let stItem = item?.startTimeH !== undefined ? item?.startTimeH?.padStart(2,'0') : "00"
            stItem+= item?.startTimeM !== undefined ? item?.startTimeM?.padStart(2,'0') : "00"
            let enItem = item?.endTimeH !== undefined ? item?.endTimeH?.padStart(2,'0') : "00"
            enItem+= item?.endTimeM !== undefined ? item?.endTimeM?.padStart(2,'0') : "00"

            x?.push(stItem)
            x?.push(enItem)

            xArray.push(x)
        })

        updateData.current = {
            workTime: xArray,
            locale: Number(locale)
        }

        exUpdate().then((e)=>{
            if(e?.success){
                if(refState.current)refState.current.show("Расписание обновлено", false, 5000)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 0)
        })


        console.log(xArray, JSON.stringify(xArray))


    }


    const setDatVal = (day:number, val: string|boolean, block:string)=>{
        const x = dayList?.map((item,idx)=>{
            if(item?.day === day){
                let vl = val
                if(block?.match(/(startTimeH)|(endtTimeH)/ui)){
                    const px  = Number(val)
                    if(isNaN(px) || px<0 || px> 24) vl = '00'
                }
                if(block?.match(/(startTimeM)|(endtTimeM)/ui)){
                    const px  = Number(val)
                    if(isNaN(px) || px<0 || px> 59) vl = '00'
                }


                item[block] = (vl)
            }
            return item
        })
        setDayList(x)

    }

    const normVal = (val: string) => {
        return val.padStart(2,'0')
    }


    const buildDayLine = ()=>{
        const x = dayList?.map((item,idx)=>{
            return(
                <div key={idx} className={styles.dayLine}>

                    <div className={styles.dayLineBlock}>
                        <div className={[styles.dayLineTitle, item?.enabled ? styles.dayOff : "" ].join(' ')}
                            onClick={()=>setDatVal(item?.day, !item?.enabled, 'enabled')}

                        >{item?.name}</div>
                        <div>
                            <input
                                value={item?.startTimeH}
                                maxLength={2}
                                className={"form-control form-control-sm"}
                                inputMode={"numeric"}
                                onBlur={(e)=>setDatVal(item?.day,normVal(e?.target?.value?.toString()),'startTimeH')}
                                onChange={(e)=>setDatVal(item?.day,(e?.target?.value?.toString()),'startTimeH')}
                                disabled={!item?.enabled}

                            />
                        </div>
                        <div className={styles.dayLineDivider}>:</div>
                        <div>
                            <input
                                value={item?.startTimeM}
                                maxLength={2}
                                className={"form-control form-control-sm"}
                                inputMode={"numeric"}
                                onBlur={(e)=>setDatVal(item?.day,normVal(e?.target?.value?.toString()),'startTimeM')}
                                onChange={(e)=>setDatVal(item?.day,(e?.target?.value?.toString()),'startTimeM')}
                                disabled={!item?.enabled}
                            />
                        </div>
                        <div className={styles.dayLineDivider}>-</div>
                        <div>
                            <input
                                value={item?.endTimeH}
                                maxLength={2}
                                className={"form-control form-control-sm"}
                                inputMode={"numeric"}
                                onBlur={(e)=>setDatVal(item?.day,normVal(e?.target?.value?.toString()),'endTimeH')}
                                onChange={(e)=>setDatVal(item?.day,(e?.target?.value?.toString()),'endTimeH')}
                                disabled={!item?.enabled}

                            />
                        </div>
                        <div className={styles.dayLineDivider}>:</div>
                        <div>
                            <input
                                value={item?.endTimeM}
                                maxLength={2}
                                className={"form-control form-control-sm"}
                                inputMode={"numeric"}
                                onBlur={(e)=>setDatVal(item?.day,normVal(e?.target?.value?.toString()),'endTimeM')}
                                onChange={(e)=>setDatVal(item?.day,(e?.target?.value?.toString()),'endTimeM')}
                                disabled={!item?.enabled}
                            />
                        </div>

                    </div>


                </div>
            )
        })

        return(
            <div className={styles.dayCont}>{x}</div>
        )
    }


    return(
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Режим работы телефонной станции"} maxWidth={"800px"}>
                <div className={styles.wrCont}>
                    <WorkLine title={"Процесс"} load={ldrLoad || ldrUpdate }></WorkLine>
                </div>
                <div className={styles.lcCont}>
                    <div className={styles.lcTitle}>Часовой пояс</div>
                    <input
                        value={localeStr}
                        maxLength={3}
                        className={"form-control form-control-sm"}
                        inputMode={"numeric"}
                        onBlur={(e)=>{
                            const x = e?.target?.value?.toString()?.trim()
                            const lc = Number(x)
                            if(isNaN(lc) || lc<-12 || lc>14){
                                setLocale(0)
                                setLocaleStr('0')
                                return
                            }
                            else setLocale(lc)
                            setLocaleStr(lc.toString())

                        }}
                        onChange={(e)=> {
                            const x = e?.target?.value?.toString()?.trim()
                            setLocaleStr(x)

                        }}
                    />


                </div>

                {buildDayLine()}
                <ErrorLineItem ref={refState}/>

                <ButtonContainer resize={true} my={15} clsCont={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={handleUpdate}
                    >Сохранить</button>

                    <button type="button" className="btn btn-secondary "
                            onClick={loadList}
                            //disabled={!crParty}
                    >Загрузить</button>

                </ButtonContainer>


            </MainFormTemplate>

        </div>
    )
}